import { Form, Select, Space } from "antd"
import React from "react"
const TimeSlotSelector = ({
    initialValue,
    label,
    controlName,
    validators,
    avalialbleSlots,
    onTimeChange,
    allTimeSelector, }: any) => {
    console.log(initialValue,
        label,
        controlName,
        validators,
        avalialbleSlots,
        onTimeChange,
        allTimeSelector,)

    return <>
        <Form.Item
            initialValue={Array.isArray(initialValue) && initialValue.length > 0 ? [...initialValue] : undefined}
            label={label}
            style={{ fontSize: 20, }}
            name={controlName}
            rules={validators}
        >
            <Select
                mode="multiple"
                allowClear
                style={{ width: '100%' }}
                placeholder="Please select"
                onChange={onTimeChange}
                options={avalialbleSlots}
                optionRender={(option) => (
                    <Space>
                        {option.data.desc}
                    </Space>
                )}
                size="large"
            />
        </Form.Item>
    </>
}

export default TimeSlotSelector